import PaginationFooter from "src/components/Shared/PaginationFooter";
import React, { useCallback, useEffect, useState } from "react";
import TRHeader from "src/components/Shared/Table/TRHeader";
import Table from "src/components/Shared/Table/Table";
import { connect } from "react-redux";
import { apiRequest } from "src/async/apiUtils";
import TableOptions from "src/components/Shared/TableOptions";
import Search from "src/components/Shared/Search";
import LogEntry from "./LogEntry";
import Button from "src/components/Shared/Buttons/Button";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

const NtificationCancelleationList = ({ notification, extraProps }) => {
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [keyword, setKeyword] = useState("");

  const [meta, setMeta] = useState({});
  const [notificanLogs, setNotificationLogs] = useState([]);
  const [notificanLogsLoaded, setNotificanLogsLoaded] = useState(false);

  const getNotificationLogs = useCallback(async () => {
    try {
      setNotificanLogsLoaded(false);
      const url = "/notifications/:notification_id/logs";
      const res = await apiRequest("get", url, {
        params: { notification_id: notification?._id },
        queries: {
          limit,
          offset,
          keyword,
        },
      });
      if (res.data.status === 200) {
        setNotificationLogs(res.data.data || []);
        setMeta(res?.data?.meta || {});
      } else {
        setNotificationLogs([]);
      }
      setNotificanLogsLoaded(true);
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit, offset, keyword, notification?._id]);

  useEffect(() => {
    getNotificationLogs();
  }, [getNotificationLogs]);

  const handlePaginationChange = ({ limit, offset }) => {
    setLimit(limit);
    setOffset(offset);
  };

  return (
    <div>
      <div className="pb-2">Displays all users who have manually canceled recieving this specific notification.</div>
      <TableOptions
        leftContent={
          <div className="flex gap-x-2">
            <div className="min-w-[210px]">
              <Search
                keyword={keyword}
                setKeyword={(val) => {
                  setOffset(0);
                  setKeyword(val);
                }}
                placeholder="Search"
                inline
              />
            </div>
            {notification.status && notificanLogs?.length > 0 && (
              <div className="animate-fade-in">
                <Button
                  version="gray"
                  loading={extraProps?.submitting}
                  disabled={extraProps?.submitting}
                  success={extraProps?.submitted}
                  hoverText="Click to make this notification visible to all users"
                  tooltipPlacement="right"
                  onClick={() => {
                    extraProps?.onSubmit({ reset_logs: true });
                  }}>
                  <ArrowPathIcon className="h-5 w-5" />
                  Reset
                </Button>
              </div>
            )}
          </div>
        }
      />
      <Table
        tableHeader={
          <TRHeader>
            <th
              scope="col"
              className="hidden rounded-tl-lg py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:table-cell sm:pl-6">
              <div className="flex gap-x-2">User</div>
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
              Client
            </th>
            <th
              scope="col"
              className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
              Date
            </th>
          </TRHeader>
        }
        colSpan="5"
        loaded={notificanLogsLoaded}
        noDataTitle="No logs found"
        dataExists={notificanLogs?.length > 0}>
        {notificanLogs?.map((item, index) => (
          <LogEntry
            key={index}
            data={item}
          />
        ))}
      </Table>
      <PaginationFooter
        itemName="Notification log"
        limit={limit}
        offset={offset}
        count={meta?.count}
        onChange={handlePaginationChange}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    me: state.auth.user,
    site: state.site,
  };
};

export default connect(mapStateToProps, {})(NtificationCancelleationList);
